"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeGhost;

/**
 * It is often handy to speak about things in a consistent manner, such as "this is a 'primary ghost'-like thing",
 * but when it comes to actually applying styles, we need to actually treat the component more as 'primary'.
 *
 * This is somewhat common when one component wraps another.
 * The wrapping component may have a `primaryGhost` theme applied to it,
 * but when it passes props to its children, they need to be styled as `primary` in order to fit in correctly.
 */
function removeGhost(str) {
  return str.replace(/ghost/gi, '');
}